import type { motDePasse as Fr } from '../fr/motDePasse';

/** « motDePasse » in English — typed on the French: a missing sentence does not compile. */
export const motDePasse: typeof Fr = {
  titre: 'Change my password',
  erreur: 'The password could not be changed.',
  fait: 'Done',
  actif: 'Your new password is active. Use it the next time you sign in.',
  fermer: 'Close',
  actuel: 'Current password',
  nouveau: 'New password',
  minimum: '8 characters minimum.',
  encore: (n: number) => `${n} more ${n === 1 ? 'character' : 'characters'}.`,
  repetez: 'Repeat the new password',
  different: 'The two do not match.',
  annuler: 'Cancel',
  changer: 'Change',
};
